import styled, { css } from 'styled-components'
import type { ComponentsTheme } from '../../providers/ComponentsThemeProvider'
import { getAutomatedStyleProp } from '../../providers/ComponentsThemeProvider'
import type { OptionProps } from './types'

export const Container = styled.label`
  display: flex;
  cursor: pointer;
`

const getColor = ({ theme }: { theme: ComponentsTheme }) => {
  if (theme.automated?.styles?.paleTextColor) {
    return theme.automated?.styles.paleTextColor
  }

  return 'var(--text-secondary)'
}

export const LabelContainer = styled.div`
  width: 100%;
  margin-left: var(--space-300);
`

export const Label = styled.div<Pick<OptionProps, 'disabled'>>`
  display: flex;
  align-items: center;
  font-size: var(--font-size-400);
  line-height: var(--font-line-height-400);
  color: ${getAutomatedStyleProp('colorOnBackground', 'var(--text-primary)')};

  user-select: none;

  ${({ disabled }) =>
    disabled &&
    css`
      color: ${getColor};
      cursor: not-allowed;
    `}
`

export const TooltipContainer = styled.div`
  position: relative;
  z-index: 10;
  margin-left: var(--space-150);
`
